import { TargomoClient } from '@targomo/core';
import { TARGOMO_TOKEN } from './constants';
import { MAP_ID } from './map.constants';
import { AddLayerOptions, SourceWithId } from '@iib/pandora-box';
import maplibregl, { LayerSpecification } from 'maplibre-gl';

const client = new TargomoClient('westcentraleurope', TARGOMO_TOKEN!);

const tileSources = {
  Wohnlage: [],
  ÖPNV: [
    {
      type: 'tgm-bus_stop',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=bus_stop&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-railway_station',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=railway_station&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
  ],
  Kultur: [
    {
      type: 'tgm-restaurant',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=restaurant&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-bar',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=bar&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-biergarten',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=biergarten&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-cafe',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=cafe&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-cinema',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=cinema&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-coffee_shop',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=coffee_shop&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-nightclub',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=nightclub&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-pub',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=pub&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-gallery',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=gallery&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-museum',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=museum&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-theatre',
      color: 'black',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=theatre&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
  ],
  Nahversorgung: [
    {
      type: 'tgm-c_kiosk',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=c_kiosk&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-supermarket',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=supermarket&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-chemist',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=chemist&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-kindergarten',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=kindergarten&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-childcare',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=childcare&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-amenity_school',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=amenity_school&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-pharmacy',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=pharmacy&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-hospital',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=hospital&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
    {
      type: 'tgm-fitness',
      color: 'white',
      textColor: 'white',
      url:
        `https://api.targomo.com/pointofinterest/{z}/{x}/{y}.mvt?apiKey=${client.serviceKey}` +
        '&group=fitness&loadAllTags=true&layerType=node&layerGeometryDetailPerTile=5',
    },
  ],
};

export const selectPOIsBasedOnSelectedOption = (option: string) => {
  return tileSources[option as keyof typeof tileSources] || [];
};

export const preloadIcons = async (map: any, selectedPOIs: any[]) => {
  for (const icon of selectedPOIs.map((item) => item.type)) {
    const path = `/assets/img/poiIcons/${icon}.png`;

    map?.loadImage(path, (error: any, image: any) => {
      if (error) throw error;
      if (!map.hasImage(icon)) map.addImage(icon, image);
    });

    for (const icon of ['tgm-circle']) {
      map.loadImage(
        `https://releases.targomo.com/tgm-icons/images/${icon}.png`,
        (error: any, image: any) => {
          if (error) throw error;
          if (!map.hasImage(icon)) map.addImage(icon, image);
        },
      );
    }

    for (const icon of ['tgm-circle']) {
      map.loadImage(
        `https://releases.targomo.com/tgm-icons/images/${icon}.png`,
        (error: any, image: any) => {
          if (error) throw error;
          if (!map.hasImage(icon)) map.addImage(icon, image);
        },
      );
    }
  }

  // Load tgm-circle icon
  const circlePath =
    'https://releases.targomo.com/tgm-icons/images/tgm-circle.png';
  map?.loadImage(circlePath);
};

export const addPOILayersToMap = async (
  selectedPOIs: any[],
  map: maplibregl.Map,
  addSource: ((mapId: string, source: SourceWithId) => void) | undefined,
  addLayer: ((mapId: string, layer: AddLayerOptions) => void) | undefined,
) => {
  await preloadIcons(map, selectedPOIs); // Preload icons

  // Remove existing layers and sources
  map.getStyle().layers.forEach((layer: any) => {
    if (
      (layer.id.includes('poi-') || layer.id.includes('tgm-')) &&
      layer['source-layer' as keyof LayerSpecification] === 'poi'
    ) {
      map.removeLayer(layer.id);
      map.removeSource(layer['source' as keyof LayerSpecification]);
    }
  });

  for (const source of selectedPOIs) {
    const sourceFinal: SourceWithId = {
      id: `poi-${source.type}-src`,
      type: 'vector',
      tiles: [source.url],
      minzoom: 15,
      attribution:
        '<a href="https://www.targomo.com/developers/resources/attribution/" target="_blank">&copy; Targomo</a>',
    };

    addSource?.(MAP_ID, sourceFinal);

    addLayer?.(MAP_ID, {
      id: `poi-${source.type}`,
      type: 'symbol',
      source: `poi-${source.type}-src`,
      'source-layer': 'poi',
      layout: {
        'icon-allow-overlap': true,
        'icon-image': `${source.type}`,
        'icon-size': ['interpolate', ['linear'], ['zoom'], 15, 0.4, 18, 0.32],
      },
      filter: ['==', ['get', 'numOfPois'], 1],
    });

    // update cursor for layer
    map.on('mouseenter', `poi-${source.type}`, () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', `poi-${source.type}`, () => {
      map.getCanvas().style.cursor = '';
    });

    // Add layer for clusters
    addLayer?.(MAP_ID, {
      id: `poi-${source.type}-many`,
      type: 'symbol',
      source: `poi-${source.type}-src`,
      'source-layer': 'poi',
      layout: {
        'icon-allow-overlap': true,
        'icon-image': 'tgm-circle',
        'icon-size': 0.3,
        'text-field': '{numOfPois}',
        'text-size': 8,
      },
      filter: ['>', ['get', 'numOfPois'], 1],
      paint: {
        'text-color': source.textColor,
      },
    });

    // Update cursor for layer
    map?.on('mouseenter', `poi-${source.type}-many`, () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', `poi-${source.type}-many`, () => {
      map.getCanvas().style.cursor = '';
    });

    // Add click event listener for POI popups
    map.on('click', `poi-${source.type}`, (event: any) => {
      let description = ``;
      // const features = map.queryRenderedFeatures(event.point, {
      //   layers: [`poi-${source.type}`],
      // });

      const poiFeatures = map
        ?.queryRenderedFeatures(event.point)
        .filter((feature) => new RegExp('poi-')?.test(feature.source));
      // get all multiple pois
      const poiManyFeatures = map
        ?.queryRenderedFeatures(event.point)
        .filter((feature) => new RegExp('-many')?.test(feature.source));

      if (poiManyFeatures.length > 0) {
        // only show multiple if overlapping
        description += `<strong>${poiManyFeatures[0].properties.numOfPois} POIs hier</strong>
							<br>Zoomen Sie herein, um Details zu sehen.`;
      } else {
        // otherwise show singular
        poiFeatures.forEach((f, _i) => {
          let type =
            f.properties.groupId === 'shop_kiosk'
              ? 'c_kiosk'
              : f.properties.groupId;
          const path = `/assets/img/poiIcons/info-${type}.png`;
          type =
            f.properties.groupId === 'shop_kiosk'
              ? 'c_kiosk'
              : f.properties.groupId
                  .split('_')
                  .map(
                    (item: string) =>
                      item.charAt(0).toUpperCase() + item.slice(1),
                  )
                  .join(' ');
          const name =
            f.properties.numOfPois === 1 ? f.properties['tag-name'] || '' : '';

          description = `<div align="center" key=${_i}>
							<img src=${path} width="20" height="20"><span>  &nbsp; &nbsp;${name}&nbsp; &nbsp;&nbsp;</span>
							</div>`;
        });
      }

      new maplibregl.Popup()
        .setLngLat(event.lngLat)
        .setHTML(description)
        .addTo(map) as maplibregl.Popup;
    });
  }
};

export const handleMapLoad = async (
  map: maplibregl.Map,
  selectedLayer: any,
  addSource: (mapId: string, source: SourceWithId) => void,
  addLayer: (mapId: string, layer: AddLayerOptions) => void,
) => {
  const selectedPOIs = selectPOIsBasedOnSelectedOption(selectedLayer);
  await addPOILayersToMap(selectedPOIs, map, addSource, addLayer);
};
